export const SORT_OPTIONS = [
  { value: "date-desc", label: "Newest first" },
  { value: "date-asc", label: "Oldest first" },
  { value: "amount-desc", label: "Amount: High to Low" },
  { value: "amount-asc", label: "Amount: Low to High" },
];

export const DEFAULT_SORT = "date-desc";

export const sortByOption = (items, sortBy, { dateKey = "date", amountKey = "amount" } = {}) => {
  const sorted = [...items];
  switch (sortBy) {
    case "date-asc":
      sorted.sort((a, b) => (a[dateKey] < b[dateKey] ? -1 : a[dateKey] > b[dateKey] ? 1 : 0));
      break;
    case "amount-desc":
      sorted.sort((a, b) => b[amountKey] - a[amountKey]);
      break;
    case "amount-asc":
      sorted.sort((a, b) => a[amountKey] - b[amountKey]);
      break;
    case "date-desc":
    default:
      sorted.sort((a, b) => (a[dateKey] < b[dateKey] ? 1 : a[dateKey] > b[dateKey] ? -1 : 0));
  }
  return sorted;
};
